import { Arrayify } from "./utils"


const formatter = new Intl.NumberFormat('en-CA', {
    style: 'currency',
    currency: 'CAD',
    maximumFractionDigits: 0,
})

export const Money = (iv) => {
    let m = formatter.format(iv.Value)
    if (iv.Type !== "Never") {
        m += "*"
    }
    return m
}
export const AddIncomeRuleText = (from, registered, maxlimits) => {

    let who = ""
    let move = "Sell"
    let fromName = ""
    let amt = ""
    let min = ""
    let max = ""
    let fromMin = ""
    let fromAcct = ""
    let maxlimit = false

    if (from.Account.Who.length === 1) {
        if (from.Account.Who[0] === "Personal") {
            who = "your"
        } else if (from.Account.Who[0] === "Spousal") {
            who = "your spousal"
        }
    } else if (from.Account.Who.length === 2) {
        who = "your personal/spousal"
    }

    if (from.Account.AccountName !== "") {
        fromName = from.Account.AccountName
        if (Arrayify(registered).includes(fromName)) { // registered
            move = "Withdraw"
        }
        if (Arrayify(maxlimits).includes(fromName)) {
            maxlimit = true
        }
        fromAcct = fromName + " account"
    } else if (from.Account.AccountType !== "") {
        fromName = from.Account.AccountType
        if (fromName === "TFSA" || fromName === "TFFHSA" || fromName === "RRSP" || fromName === "RESP") {
            move = "Withdraw"
        }
        if (fromName === "DCPP" || fromName === "LIRA") {
            move = "Withdraw"
            maxlimit = true
        }
        fromAcct = fromName + " accounts"
    }
    let upTo = ""
    if (from.OnlyRequired) {
        upTo = " up to "
    }
    let inclMin = ""
    if (from.IncludesMinimum) {
        inclMin = " (includes minimums)"
    }
    let maxLimit = ""
    if (maxlimit) {
        maxLimit = "of the maximum withdrawal limit"
    } else {
        maxLimit = "of the value"
    }

    let noFrom = false

    if (from.Method === "Percent Available From") {
        amt = upTo + from.Percent + "% " + inclMin + maxLimit + " from " + who + " " + fromAcct
        noFrom = true
    } else if (from.Method === "Flat Value") {
        amt = upTo + Money(from.Value) + inclMin
    } else if (from.Method === "Percent Required") {
        amt = upTo + from.Percent + "% of the remaining amount required"
    } else if (from.Method === "Minimum Income") {
        amt = "enough to have" + upTo + Money(from.Value) + " as a minimum income"
    } else if (from.Method === "Minimum Taxable Income") {
        amt = "enough to generate" + upTo + Money(from.Value) + " as a minimum taxable income"
    } else if (from.Method === "Minimum Marginal Tax Rate") {
        amt = "enough to ensure " + upTo + from.Percent + "% marginal tax rate"
    }

    if (from.Min.Value !== 0) {
        min = ", no less than " + Money(from.Min)
    }
    if (from.Max.Value !== 0) {
        max = ", no more than " + Money(from.Max)
    }
    if (from.FromMin.Value !== 0) {
        fromMin = ", keeping at least " + Money(from.FromMin) + " in " + who + " " + fromAcct
    }
    let from2se = ""
    if (!noFrom) {
        from2se = "from " + who + " " + fromAcct
    }

    let text = move + " " + amt + " " + from2se + min + max + fromMin
    return text

}
